/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-02T10:33:18-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-18T10:03:26-07:00
*/



import React, { Component } from 'react';
import glamorous, { Div } from 'glamorous';
import Container from '../../blocks/Container';
import Panel from '../../common/Panel';
import Header from '../../blocks/Header';
import InputGroup from '../../blocks/InputGroup';
import Select from '../../common/Select';
import LongText from '../../common/LongText';
import Checkbox from '../../common/Checkbox';
import Button from '../../blocks/Button';
import AutoCompleteInput from '../../common/AutoCompleteInput';
import { dimensions, comboBox, textArea, textInput, spacing, box, borders, type } from '../../../style';
import { extractLocationData, geocodeByPlaceId } from '../../../common'
import TextLink from '../../common/TextLink';

const TitleSpan = glamorous.span({
  ...type.title.XS
});

class ProfileEdit extends Component {

  constructor(props) {
    super(props);

    // copy initial props to state.
    this.state = Object.assign({},this.props.profile, { address: '' });

    // this bindings
    this.submit = this.submit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
    this.locationSelectHandler = this.locationSelectHandler.bind(this);
    this.inputOnChange = this.inputOnChange.bind(this);
    this.resetLocation = this.resetLocation.bind(this);
  }

  submit() {
    // remove location data
    this.resetLocation();
    // submit form update
    this.props.update(this.state, this.props.username);
  }



  handleSubmit(e) {
    // prevent default form submission
    e.preventDefault();
    // if new location provided, copy over data.
    if(this.state.NEWLOCATION !== undefined) {
      // extract new location, and submit
      let newLocation = extractLocationData(this.state.NEWLOCATION);
      // submit updated form with new location
      this.setState(newLocation, function() { this.submit() });
    } else {
      // otherwise, just submit form data (without location).
      this.submit();
    }
  }
  onChangeHandler(e) { this.setState({[e.target.id]: e.target.value}) }
  onCheckboxChangeHandler(e) {
    // update checkbox
    let newState = Object.assign({},this.state);
    newState[e.target.id] = !newState[e.target.id];
    this.setState(newState);
  }

  locationSelectHandler(address, placeId) {
    // verify valid location from Google sent
    geocodeByPlaceId(placeId)
      .then((results) => {
        let place = results[0];
        let placeData = extractLocationData(place);
        
        let locText = `${placeData.city ? placeData.city + ', ' : ''}` +
          `${placeData.region ? placeData.region + ', ' : ''}` +
          `${placeData.country ? placeData.country : ''}`;

        if(place.geometry) {
          this.setState({ 'NEWLOCATION': place, 'address': locText });
        }
      })
      .catch((error) => {
        console.error('Issue with Geocoding: ', error);
      });
  }

  resetLocation() { 
    this.setState({NEWLOCATION: undefined}); 
  }

  inputOnChange(value) {
    this.setState({ address: value });
  }

  componentWillReceiveProps(nextProps) {
    // new profile props passed, apply them to state.
    if(this.props.profile != nextProps.profile)
    this.setState({...nextProps.profile});
  }

  render() {
    const inputProps = {
      value: this.state.address || '',
      id: 'autocompleteLocation',
      placeholder: 'Enter a new location',
      type: 'text',
      className: ['textInput u-sizeFull'],
      onChange: this.inputOnChange
    }

    return (
      <form id="profile-edit" onSubmit={this.handleSubmit}>
      <Container screenTop padding='large'>
      <Panel withHeader>
          <Header>
            <TitleSpan>Required</TitleSpan>
          </Header>

          <InputGroup inputLabel="Ethnicity" errors={this.props.errors.ethnicity}>
            <Select fit value={this.state.ethnicity} id="ethnicity" onChange={this.onChangeHandler} error={this.props.errors.ethnicity}>
              <option value>—</option>
              <option value={'Asian'}>Asian</option>
              <option value={'Black / African Descent'}>Black / African Descent</option>
              <option value={'Latin / Hispanic'}>Latin / Hispanic</option>
              <option value={'East Indian'}>East Indian</option>
              <option value={'Middle Eastern'}>Middle Eastern</option>
              <option value={'Mixed Race'}>Mixed Race</option>
              <option value={'Native American'}>Native American</option>
              <option value={'Pacific Islander'}>Pacific Islander</option>
              <option value={'White / Caucasian'}>White / Caucasian</option>
              <option value={'Other Ethnicity'}>Other Ethnicity</option>
            </Select>
          </InputGroup>

          <InputGroup inputLabel="Body Type" errors={this.props.errors.body_type}>
            <Select fit value={this.state.body_type} id="body_type" onChange={this.onChangeHandler} error={this.props.errors.body_type}>
              <option value>—</option>
              <option value={'Slim / Slender'}>Slim / Slender</option>
              <option value={'Athletic'}>Athletic</option>
              <option value={'Average'}>Average</option>
              <option value={'A Few Extra Pounds'}>A Few Extra Pounds</option>
              <option value={'Full / Overweight'}>Full / Overweight</option>
            </Select>
          </InputGroup>

          <InputGroup inputLabel="Relationship" errors={this.props.errors.relationship_status}>
            <Select fit value={this.state.relationship_status} id="relationship_status" onChange={this.onChangeHandler}>
              <option value>—</option>
              <option value={'Single'}>Single</option>
              <option value={'Divorced'}>Divorced</option>
              <option value={'Widowed'}>Widowed</option>
              <option value={'Separated'}>Separated</option>
              <option value={'Married But Looking'}>Married But Looking</option>
              <option value={'In An Open Relationship'}>In An Open Relationship</option>
            </Select>
          </InputGroup>

          <InputGroup inputLabel="Interested in traveling with" errors={this.props.errors.looking_male}>
            <Checkbox inline={true} value={this.state.looking_male} id="looking_male" onChange={this.onCheckboxChangeHandler} label="Men"/>
            <Checkbox inline={true} value={this.state.looking_female} id="looking_female" onChange={this.onCheckboxChangeHandler} label="Women"/>
          </InputGroup>

          <InputGroup inputLabel="Looking For" errors={this.props.dating_just_dating}>
            <Checkbox inline value={this.state.dating_just_dating} id="dating_just_dating" onChange={this.onCheckboxChangeHandler} label="Dating" />
            <Checkbox inline value={this.state.dating_friendship} id="dating_friendship" onChange={this.onCheckboxChangeHandler} label="Friendship" />
            <Checkbox inline value={this.state.dating_marriage} id="dating_marriage" onChange={this.onCheckboxChangeHandler} label="Longterm relationship" />
            <Checkbox inline value={this.state.dating_sugar} id="dating_sugar" onChange={this.onCheckboxChangeHandler} label="Travel partner" />
            <Checkbox inline value={this.state.dating_married} id="dating_married" onChange={this.onCheckboxChangeHandler} label="Discreet affair" />
            <Checkbox inline value={this.state.dating_adult} id="dating_adult" onChange={this.onCheckboxChangeHandler} label="Casual dating" />
          </InputGroup>

          {/* -- location -- */}
          <InputGroup inputLabel="Where do you live">
            { this.props.profile.city && this.props.profile.country && this.props.profile.region &&
            <Div marginBottom={8}>
              {this.state.city}, {this.state.region}, {this.state.country}
            </Div>
            }
              <AutoCompleteInput
                inputProps={inputProps}
                onSelect={this.locationSelectHandler}
              />

          </InputGroup>

          <InputGroup inputLabel="Describe Yourself" errors={this.props.errors.description}>
            <LongText placeholder="Write a little bit about yourself." rows={10} name="description"
              value={this.state.description} id="description" onChange={this.onChangeHandler} error={this.props.errors.description}/>
          </InputGroup>
          {/* Describe Yourself */}
        </Panel>
        <Panel withHeader>
          <Header>
            <TitleSpan>Optional</TitleSpan>
          </Header>

            {/* Height */}
            <InputGroup inputLabel="Height">
              <Select fit value={this.state.height} id="height" onChange={this.onChangeHandler}>
                <option value>—</option>
                <option value={`< 5' (<150cm)`}>{`< 5' (<150cm)`}</option>
                <option value={`5'0" (152cm)`}>{`5'0" (152cm)`}</option>
                <option value={`5'1" (155cm)`}>{`5'1" (155cm)`}</option>
                <option value={`5'2" (157cm)`}>{`5'2" (157cm)`}</option>
                <option value={`5'3" (160cm)`}>{`5'3" (160cm)`}</option>
                <option value={`5'4" (163cm)`}>{`5'4" (163cm)`}</option>
                <option value={`5'5" (165cm)`}>{`5'5" (165cm)`}</option>
                <option value={`5'6" (168cm)`}>{`5'6" (168cm)`}</option>
                <option value={`5'7" (170cm)`}>{`5'7" (170cm)`}</option>
                <option value={`5'8" (173cm)`}>{`5'8" (173cm)`}</option>
                <option value={`5'9" (175cm)`}>{`5'9" (175cm)`}</option>
                <option value={`5'10" (178cm)`}>{`5'10" (178cm)`}</option>
                <option value={`5'11" (180cm)`}>{`5'11" (180cm)`}</option>
                <option value={`6'0" (183cm)`}>{`6'0" (183cm)`}</option>
                <option value={`6'1" (185cm)`}>{`6'1" (185cm)`}</option>
                <option value={`6'2" (188cm)`}>{`6'2" (188cm)`}</option>
                <option value={`6'3" (191cm)`}>{`6'3" (191cm)`}</option>
                <option value={`6'4" (193cm)`}>{`6'4" (193cm)`}</option>
                <option value={`6'5" (196cm)`}>{`6'5" (196cm)`}</option>
                <option value={`6'6" (198cm)`}>{`6'6" (198cm)`}</option>
                <option value={`6'7" (201cm)`}>{`6'7" (201cm)`}</option>
                <option value={`6'8" (203cm)`}>{`6'8" (203cm)`}</option>
                <option value={`6'9" (206cm)`}>{`6'9" (206cm)`}</option>
                <option value={`6'10" (208cm)`}>{`6'10" (208cm)`}</option>
                <option value={`6'11" (211cm)`}>{`6'11" (211cm)`}</option>
                <option value={`7'0" (214cm)`}>{`7'0" (214cm)`}</option>
                <option value={`> 7'0" (> 215cm)`}>{`> 215cm`}</option>
              </Select>
            </InputGroup>

            <InputGroup inputLabel="Education">
              <Select fit value={this.state.education} id="education" onChange={this.onChangeHandler}>
                <option value>—</option>
                <option value={'High School'}>High School</option>
                <option value={'Some College'}>Some College</option>
                <option value={'Associates Degree'}>Associates Degree</option>
                <option value={'Bachelors Degree'}>Bachelors Degree</option>
                <option value={'Graduate Degree'}>Graduate Degree</option>
                <option value={'PhD / Post Doctoral'}>PhD / Post Doctoral</option>
              </Select>
            </InputGroup>
            {/* Religion */}
            <InputGroup inputLabel="Religion">
              <Select fit value={this.state.religion} id="religion" onChange={this.onChangeHandler}>
                <option>—</option>
                <option>Agnostic / Non-religious</option>
                <option>Buddhist</option>
                <option>Christian (Catholic)</option>
                <option>Christian (Orthodox)</option>
                <option>Christian (Protestant)</option>
                <option>Christian (Mormon)</option>
                <option>Christian (Other)</option>
                <option>Hindu</option>
                <option>Jewish</option>
                <option>Muslim</option>
                <option>New Age (Spiritual But Not Religious)</option>
                <option>Other Religion</option>
              </Select>
            </InputGroup>
            {/* Children */}
            <InputGroup inputLabel="Children">
              <Select fit value={this.state.children} id="children" onChange={this.onChangeHandler}>
                <option>—</option>
                <option>No Children</option>
                <option>1 Child</option>
                <option>2 Children</option>
                <option>3 Children</option>
                <option>> 3 Children</option>
              </Select>
            </InputGroup>

            <InputGroup inputLabel="Smoking">
              <Select fit value={this.state.smoking} id="smoking" onChange={this.onChangeHandler}>
                <option>—</option>
                <option>Non-Smoker</option>
                <option>Light Smoker</option>
                <option>Heavy Smoker</option>
              </Select>
            </InputGroup>

            <InputGroup inputLabel="Drinking">
              <Select fit value={this.state.drinking} id="drinking" onChange={this.onChangeHandler}>
                <option>—</option>
                <option>Non-Drinker</option>
                <option>Social Drinker</option>
                <option>Heavy Drinker</option>
              </Select>
            </InputGroup>


            <InputGroup inputLabel="Why you want to travel">
              <LongText placeholder="Why You Want to Travel" rows={10} value={this.state.seeking}
                id="seeking" onChange={this.onChangeHandler} />
            </InputGroup>
        </Panel>
      </Container>
      <Container padding='large'>
        <Button size='large' variant="primary">Save Profile</Button>
      </Container>
    </form>
    );
  }
}


export default ProfileEdit;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/ProfileEdit.jsx